import {createApp} from "petite-vue";
import SimpleLightbox from "simple-lightbox";
import Swiper from "swiper";
import {Navigation, Pagination} from "swiper/modules";
import {initMap} from "./components/map";
import {isInViewport} from "./utils/is-in-viewport";

import.meta.env.DEV && import("@styles/salon.sass");

interface Header {
    opened: boolean;

    handleOpenedHeader(state: boolean): void;
}

const headerEl = document.querySelector<HTMLElement>('[data-header]'),
    headerScope: Header = {
        opened: false,

        handleOpenedHeader(state) {
            document.body.classList.toggle("u-hiddenOverflow", state);
        },
    };

if (headerEl) {
    createApp(headerScope).mount(headerEl);

}

(async () => {

    const mapEl = document.querySelector<HTMLElement>("[data-map]")
    mapEl && (document.body.classList.contains('archive') || isInViewport(mapEl, 4)) ? await initMap(mapEl)
        : window.addEventListener("scroll", async () => {
            isInViewport(mapEl, 4) && await initMap(mapEl)
        })
})();

//----------------------------------------Lightbox

(() => {

    const galleryElement = document.querySelector(".wp-block-gallery");
    new SimpleLightbox({
        elements: ".SalonHero-galleryImage > a",
    });
})();

//----------------------------------Swipers


(() => {
    const swiperSalonHeroContainer = document.querySelector("[data-salon-hero-swiper]") as HTMLElement | null;

    if (!swiperSalonHeroContainer) return;

    const swiperSalonHero = new Swiper(swiperSalonHeroContainer, {
        modules: [Pagination],
        slidesPerView: 3,
        slidesPerGroup: 1,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        loop: true,
    });
})();

(() => {
    const swiperTestimonialsContainer = document.querySelector("[data-testimonials-swiper]") as HTMLElement | null;

    if (!swiperTestimonialsContainer) return;

    const swiperTestimonials = new Swiper(swiperTestimonialsContainer, {
        modules: [Pagination, Navigation],
        slidesPerView: 1,
        slidesPerGroup: 1,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        centeredSlides: false,
        breakpoints: {

            1023: {
                slidesPerView: 3,
                centeredSlides: true,
            },
            600: {
                slidesPerView: 2,
                centeredSlides: false,
            },
        },
        spaceBetween: 12,
        loop: true,
    });
})();


//--------------------------------------------Salon - načíst další služby

(() => {
    const button = document.getElementById("load-more-services");
    const grid = document.getElementById("salon-services-grid");
    const allItems = grid?.querySelectorAll(".SalonServices-item");
    const initialVisibleCount = 6;

    if (!button || !allItems || allItems.length <= initialVisibleCount) return;

    button.addEventListener("click", () => {
        const expanded = button.dataset.expanded === "true";

        allItems.forEach((item, index) => {
            if (index >= initialVisibleCount) {
                if (expanded) {
                    item.classList.add("is-hidden");
                } else {
                    item.classList.remove("is-hidden");
                }
            }
        });

        button.dataset.expanded = String(!expanded);
        button.textContent = expanded ? "Načíst další" : "Skrýt služby";

        if (expanded) {
            const sixthCard = allItems[initialVisibleCount - 1];
            if (sixthCard) {
                const offset = 80;
                const top = sixthCard.getBoundingClientRect().top + window.scrollY - offset;

                window.scrollTo({
                    top,
                    behavior: 'smooth'
                });
            }
        }
    });
})();





